import React, { useState } from 'react';
import PerformanceTable from './components/PerformanceTable';
import PerformanceTools from './components/PerformanceTools';
// import PerformanceFormModel from './components/PerformanceFormModel';

const initialState = {
  isModal: { model: false, submit: false },
  modalHeader: { title: '', isEdit: false, editId: '' },
  editKPIData: {},
  search: '',
  isDelete: { id: '', status: '' },
  selectEmployeeData: [],
  selectDesignationData: [],
  selectGender: [],
  selectMaritalStatus: [],
  selectDepartmentData: [],
  currentPage: 1,
  rowsPerPage: 10,
  isNext: false,
  sortField: 'userName',
  sortDirection: false,
  loading: false,
  dropdownDataStore: [],
  currentPageDropdown: 1,
  rowsPerPageDropdown: 10,
  dropdownDesignationData: [],
  dropdownDepartmentData: [],
  currentPageDesignationDropdown: 1,
  rowsPerPageDropdownDesignation: 10,
  currentPageDepartmentDropdown: 1,
  rowsPerPageDropdownDepartment: 10
};

const PerformanceList = () => {
  const [state, setState] = useState(initialState);

  return (
    <div className="container-xxl">
      <PerformanceTools state={state} setState={setState} />

      <PerformanceTable state={state} setState={setState} />
    </div>
  );
};

export default PerformanceList;
